<template>
  <div class="divider">
    <span :style="{ padding: `0 ${offset}px` }"><slot /></span>
  </div>
</template>

<script>
export default {
  name: 'Divider',
  props: {
    offset: {
      type: Number,
      default: 40
    }
  }
}
</script>

<style scoped lang="scss">
.divider {
  margin: 24px 36px 16px;
  text-align: center;
  position: relative;
  display: flex;
  justify-content: center;
  height: 20px;

  @include md-and-down {
    margin: 24px 0 16px;
  }

  span {
    margin-top: 0;
    position: absolute;
    background-color: $white;
    color: $french-gray;
  }

  &:before {
    content: '';
    left: 0;
    height: 1px;
    width: 100%;
    bottom: 0;
    background-color: $whisper;
    position: absolute;
    top: 8px;
  }
}
</style>
